import flatpickr from 'flatpickr';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';

// The view models bind dates as dd/MM/yyyy (en-GB), so that's what the inputs keep.
const defaults = {
  dateFormat: 'd/m/Y',
  allowInput: true,
  disableMobile: true,
  locale: { firstDayOfWeek: 1 },
};

export const monthOptions = () => ({
  plugins: [monthSelectPlugin({ shorthand: true, dateFormat: 'M-Y', altFormat: 'F Y' })],
});

export function enhanceDate(input, options = {}) {
  input._flatpickr?.destroy();
  return flatpickr(input, { ...defaults, ...options });
}

const earliest = (...dates) => dates.filter(Boolean).reduce((min, date) => (min === null || date < min ? date : min), null);

// .input-daterange pairs a start and end input so the end can't come before the
// start; .input-daterange-today also stops new dates being picked in the past
// (an existing earlier value is kept selectable so editing doesn't clear it).
function enhanceRange(range) {
  const [start, end] = range.querySelectorAll('input[type=text], input:not([type])');

  if (!end) {
    if (start) enhanceDate(start);
    return;
  }

  const parse = (input) => (input.value ? flatpickr.parseDate(input.value, defaults.dateFormat) : null);
  const futureOnly = range.classList.contains('input-daterange-today');
  const today = new Date(new Date().setHours(0, 0, 0, 0));
  const startMin = futureOnly ? earliest(today, parse(start)) : null;
  const endMin = futureOnly ? earliest(today, parse(end)) : null;

  let endPicker;

  const startPicker = enhanceDate(start, {
    minDate: startMin,
    onChange: ([date]) => {
      // Move the end first: raising minDate past it would clear it.
      const current = endPicker.selectedDates[0];

      if (date && current && current < date) {
        endPicker.setDate(date, true);
      }

      endPicker.set('minDate', date ?? endMin);
    },
  });

  endPicker = enhanceDate(end, {
    minDate: earliest(parse(start), parse(end)) ?? endMin,
    onChange: ([date]) => startPicker.set('maxDate', date ?? null),
  });
}

export function enhanceDates(root = document) {
  root.querySelectorAll('input.datepicker').forEach((input) => enhanceDate(input));
  root.querySelectorAll('.input-daterange').forEach(enhanceRange);
}
